import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
export function ServicesSection() {
  const {
    t
  } = useLanguage();
  return <section id="services" className="relative py-32 lg:py-40 px-6 bg-[#0A0A0A] text-white overflow-hidden" data-id="element-234">
      <div className="absolute inset-0 opacity-5" data-id="element-235">
        <div className="absolute inset-0 bg-gradient-to-br from-[#D4AF37] via-transparent to-transparent" data-id="element-236"></div>
      </div>
      <div className="max-w-[1800px] mx-auto relative z-10" data-id="element-237">
        <div className="flex justify-between items-start" data-id="element-238">
          <h2 className="font-serif text-4xl md:text-6xl lg:text-7xl text-white leading-none font-light tracking-tight" data-id="element-239">
            {t('services.title')}
          </h2>
          <span className="text-[10px] tracking-[0.4em] uppercase opacity-30 mt-6 hidden lg:block font-light" data-id="element-240">
            {t('services.subtitle')}
          </span>
        </div>
      </div>
    </section>;
}